module.exports = __webpack_public_path__ + "static/media/grastorpvapen.abd60564.png";